<div 
    class="body"
    @show  
    [style.gridAutoRows]="rowPercentage" 
    style.gridTemplateColumns="repeat({{columns}}, minmax(100px, 1fr))"
    #startpageWidgetInner>

    <ng-container *ngIf="(widgetViewStandaloneComponentService.viewMode$|async) === widgetViewStandaloneComponentService.WidgetViewStandaloneModes.ADD_WIDGET_MODE; else defaultMode">

        <ng-container *ngFor="let row of grid | keyvalue">

            <ng-container *ngFor="let cell of row.value | keyvalue">

                <div 
                    (click)="cellClicked(cell.value)" 
                    [style.grid-column-start]="cell.value.column"
                    [style.grid-column-end]="cell.value.column" 
                    [style.grid-row-start]="cell.value.row"
                    [style.grid-row-end]="cell.value.row" 
                    class="grid-cell"
                    [ngClass]="cell.value.blocked? 'blocked': 'unblocked'"
                ></div>

            </ng-container>

        </ng-container>

    </ng-container>   

    <ng-template #defaultMode>

        <ng-container *ngFor="let widget of widgets">

            <div 
                class="widget-outer" 
                [style.grid-column-start]="widget.widgetx + 1"
                [style.grid-column-end]="widget.widgetx + widget.widgetw + 1"
                [style.grid-row-start]="widget.widgety + 1" 
                [style.grid-row-end]="widget.widgety + widget.widgeth + 1"
                [ngResizable]="(widgetViewStandaloneComponentService.viewMode$|async) === WidgetViewStandaloneModes.DRAG_AND_RESIZE_MODE" 
                [ngDraggable]="(widgetViewStandaloneComponentService.viewMode$|async) === WidgetViewStandaloneModes.DRAG_AND_RESIZE_MODE"
                (endOffset)="onMoveEnd($event, widgetTemplate, widget)" 
                [rzHandles]="'se'"
                (rzStop)="onResizeEnd($event, widget)" 
                #widgetTemplate="ngDraggable">

                <app-widget 
                    #currentWidget 
                    [widget]="widget" 
                    (changeWidgetTypeEmitter)="changeWidgettype(widget, currentWidget)">
                </app-widget>

            </div>

        </ng-container>

    </ng-template>

    <div class="placeholder" [class.visible]="(widgetViewStandaloneComponentService.viewMode$|async) === WidgetViewStandaloneModes.DRAG_AND_RESIZE_MODE" [style.grid-row-end]="rows + 1" [style.grid-column-end]="columns + 1"></div>

</div>

<div *ngIf="(widgetViewStandaloneComponentService.showControlBar$|async)" @show class="mode-control" ngDraggable>
    <mat-icon class="icon" [class.active]="(widgetViewStandaloneComponentService.viewMode$|async) === WidgetViewStandaloneModes.DRAG_AND_RESIZE_MODE"
        [matTooltip]="(widgetViewStandaloneComponentService.viewMode$|async) === WidgetViewStandaloneModes.DRAG_AND_RESIZE_MODE? 'Widgets bewegen deaktivieren': 'Widgets bewegen aktivieren'"
        (click)="widgetViewStandaloneComponentService.toggleControlBar()">
        zoom_out_map
    </mat-icon>

    <mat-icon class="icon" matTooltip="Neues Widget hinzufügen" (click)="widgetViewStandaloneComponentService.addWidget()">
        library_add
    </mat-icon>

    <mat-icon class="icon" [class.active]="deleteMode"
        [matTooltip]="deleteMode? 'Widgets löschen Modus deaktivieren': 'Widgets löschen Modus aktivieren'"
        (click)="deleteMode = !deleteMode">
        delete_forever
    </mat-icon>

    <mat-icon class="icon" matTooltip="Zeile unten einfügen" (click)="addRow()">
        border_bottom
    </mat-icon>

    <mat-icon class="icon" matTooltip="Spalte rechts hinzufügen" (click)="addColumn()">
        border_right
    </mat-icon>

    <mat-icon class="icon" matTooltip="Standartansicht herstellen (STRG + C)" style="color: #ff5050" (click)="widgetViewStandaloneComponentService.toggleControlBar()">
        clear
    </mat-icon>

</div>
